// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1ZABA","gfeWrapper":"CalendarEvent_gfeWrapper__1SUUL"};